import React, { Component } from 'react';
import Typing from "./../typing/index";
import TypingAnima from 'react-typing-animation';

class ChartBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: true
        }
        setTimeout(() => {
            this.cond = true;
            this.setState({
                type: false
            })
        }, 1000)
    }
    shouldComponentUpdate() {
        if (this.cond) {
            this.cond = false;
            return true;
        }
        return false;
    }
    render() {
        const { text, afterStatementEnds } = this.props;
        if (this.state.type) {
            return <Typing />
        }
        return (
            <div className="final-div">
                <span className="chat-text">
                    <TypingAnima speed={20} hideCursor={true} onFinishedTyping={() => {
                        afterStatementEnds();
                    }}>
                        <span style={{ display: "flex", justifyContent: "flex-start" }}> {text}</span>
                    </TypingAnima>
                </span>
            </div>
        );
    }
}

export default ChartBox;



// WEBPACK FOOTER //
// /src/call/container/chatbox/chatbox.js